import React from 'react'
import './index.scss'
import ShowElement from '../ShowElement'

import HolzwegLogoSmall from '../HolzwegLogoSmall'

import IphoneX from '../../assets/iphoneX.webp'
import Logo from '../../assets/IKB_Logo_CMYK_Rot_Schwarz_300dpi.webp'
import MyMan from '../../assets/di.harald.schneider.webp'

const TopReferences = () => (
  <div className="top-references">
    <div className="top-references__headline headline headline--centered">
      <h2>Top Referenzen</h2>
    </div>
    <div className="top-references__container">
      <div className="top-references__hw-logo">
        <HolzwegLogoSmall />
      </div>
      <ShowElement threshold="0.2">
        {showElement => (
          <div className={showElement ? 'animate top-references__phone' : 'top-references__phone'}>
            <img src={IphoneX} loading='lazy' />
            <iframe src="https://www.ikb.at/privat/" loading="lazy" />
            <div className="top-references__logo">
              <img src={Logo} loading='lazy' />
              <span>Projekt: Relaunch Webseite</span>
              <span>Innsbrucker Kommunalbetriebe AG</span>
            </div>
            <p>Scrollen Sie <br /> im Smartphone!</p>
          </div>
        )}
      </ShowElement>
      <ShowElement threshold="0">
        {showElement => (
          <div className={showElement ? 'animate top-references__text' : 'top-references__text'}>
            <p>Performance Steigerung durch präzises Nachschärfen der Accesibility und State-of-the-art Design in effizientem Umsetzungszeitraum</p>
          </div>
        )}
      </ShowElement>
    </div>
    <ShowElement threshold="0.1">
      {showElement => (
        <div className={showElement ? 'animate top-references__ceo' : 'top-references__ceo'}>
          <h4>DI Harald Schneider</h4>
          <span>Vorstandsvorsitzender bis Ende 2017</span>
          <img src={MyMan} loading='lazy' />
        </div>
      )}
    </ShowElement>
    <ShowElement threshold="0.2">
      {showElement => (
        <div className={showElement ? 'animate top-references__description' : 'top-references__description'}>
          <div className="top-references__description-left">
            <a href="https://www.ikb.at" className="button button--color-black">Launch ibk.at</a>
          </div>
          <div className="top-references__description-right">
            <p><i>“Das Projekt war ein sehr erfolgreiches Miteinander. Das strukturierte und gleichzeitig flexible Projektmanagement war ein wesentlicher Erfolgsfaktor.</i></p>
            <p><i>Denn neben einem anspruchsvollen Design und einer breiten Produktpalette war auch der Zeitrahmen ein herausfordernder Aspekt in der Umsetzung.”</i></p>
          </div>
        </div>
      )}
    </ShowElement>
  </div>
)

export default TopReferences
